module.exports = __webpack_public_path__ + "static/media/arrow-small-default.c92b5924.svg";